import { Component } from '@verndale/core';
import Swiper from 'swiper/core';
import { addGenericSwiperNav } from '../helpers/slider-nav';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $slider: this.el._$('.swiper-container'),
      $prev: this.el._$('.slider-nav__prev'),
      $next: this.el._$('.slider-nav__next'),
      $videoButtons: this.el._$$('.inline-video__play'),
      $slides: this.el._$$('.swiper-slide'),
      $videos: this.el._$$('.inline-video')
    };

    this.videoInitiatedClass = 'image-video-gallery__slide--video-initiated';
    this.disableTabIndexOnVideoButtons();
    this.slide();
  }

  addListeners() {
    this.swiper.on('slideChange', this.handleSlideChange.bind(this));
    this.dom.$videos._on(
      'videoinitiated',
      this.handleVideoInitiated.bind(this)
    );
    this.dom.$videos._on('resetcomplete', this.handleResetComplete.bind(this));
    if (this.el._$('.image-video-gallery__caption-no-overlay') !== null) {
      window._on('blur', this.handleVideoNoCaptionClick.bind(this));
    }
  }

  handleSlideChange() {
    const $video = this.dom.$slides[this.swiper.previousIndex]?._$(
      '.inline-video'
    );
    const event = new CustomEvent('reset');
    const $iframe = $video?._$('iframe.inline-video__video');

    if ($iframe) {
      const src = $iframe.src;
      window.requestAnimationFrame(() => ($iframe.src = ''));
      setTimeout(() => ($iframe.src = src), 350);
    }

    $video?.dispatchEvent?.(event);
    this.enableTabIndexActiveButton();
  }

  handleVideoInitiated(e) {
    const $slide = e.target.closest('.image-video-gallery__slide');
    $slide.classList.add(this.videoInitiatedClass);
  }

  handleResetComplete(e) {
    const $slide = e.target.closest('.image-video-gallery__slide');
    $slide.classList.remove(this.videoInitiatedClass);
  }

  disableTabIndexOnVideoButtons() {
    this.dom.$videoButtons.forEach(el => el.setAttribute('tabindex', -1));
  }

  enableTabIndexActiveButton() {
    const $activeVideoPlay = this.dom.$slides[this.swiper.activeIndex]?._$(
      '.inline-video__play'
    );
    $activeVideoPlay?.setAttribute('tabindex', 0);
  }

  handleVideoNoCaptionClick(e) {
    if (document.activeElement.classList.contains('inline-video__video')) {
      const $slide = document.activeElement.closest('.image-video-gallery__slide');
      const $caption = $slide?._$('.image-video-gallery__caption-no-overlay');
      $caption?.classList.add('hidden');
    }
  }

  slide() {
    this.swiper = new Swiper(this.dom.$slider, {
      lazy: false,
      autoHeight: true,
      preloadImages: true,
      ...addGenericSwiperNav(this.el)
    });

    this.enableTabIndexActiveButton();
  }
}

export default Module;
